module.exports = __webpack_public_path__ + "static/students-at-border-fence-d628cbddba5117f36c81903f166d3290.jpg";